import { render, staticRenderFns } from "./ImportHistoryTable.vue?vue&type=template&id=c7742768&scoped=true"
import script from "./ImportHistoryTable.vue?vue&type=script&lang=js"
export * from "./ImportHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ImportHistoryTable.vue?vue&type=style&index=0&id=c7742768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7742768",
  null
  
)

export default component.exports